<template>
  <aside class="sidebar sidebar--show">
    <span v-if="isLoadingCamera" class="w-full py-2 text-center text-grey font-semibold animate-pulse">
      Loading...
    </span>
    <template v-else>
      <!-- Info -->
      <div class="w-full flex items-center">
        <span class="font-semibold mr-3"> Total Camera </span>
        <span class="h-6 px-2 inline-block rounded-full bg-primary text-white">
          {{ totalCamera }}
        </span>
      </div>
      <!-- Filter -->
      <div class="w-full flex flex-col mb-3">
        <vs-input v-model="search" icon="search" placeholder="Filter" class="search-input" />
      </div>
      <!-- Tree View -->
      <vue-custom-scrollbar class="treview-wrapper">
        <ul class="sidebar__list">
          <li v-for="area in filteredCamera" v-if="area.aksesCameraCam.length > 0" :key="area.areaId" :class="{
            'sidebar__list-item--open': area.show,
          }" class="sidebar__list-item">
            <div>
              <vs-icon @click="area.show = !area.show" icon="arrow_right" />
              <!-- <vs-icon :icon="area.show ? 'folder_open' : 'folder'" /> -->
              <input class="mr-1" type="checkbox" v-model="area.isSelected" @change="checkAreaInput(area)" :true-value="1" :false-value="0" />
              <span @click="area.show = !area.show">
                {{ area.areaName }}
              </span>
            </div>
            <ul class="sidebar__list" v-show="area.show">
              <li v-for="camera in area.aksesCameraCam" :key="camera.cameraId" class="sidebar__list-item">
                <div>
                  <input class="ml-3 mr-1" type="checkbox" v-model="camera.isSelected" @change="checkCameraInput(area, camera)" :true-value="1" :false-value="0" />
                  <vs-icon icon="videocam" />
                  <span>
                    {{ camera.cameraName }}
                  </span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </vue-custom-scrollbar>
    </template>
  </aside>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  props: ['edit','value'],
  data() {
    return {
      isLoadingCamera: false,
      cameras: [],
      search: "",
    }
  },
  components: { vueCustomScrollbar },
  mounted() {
    this.processCameraLists();
  },
  computed: {
    totalCamera() {
      let data = [];
      for (let area of this.filteredCamera) {
        for (let camera of area.aksesCameraCam) {
          data.push(camera);
        }
      }
      return data.length;
    },
    filteredCamera() {
      if (!this.search) return this.cameras;
      return this.cameras.map((area, i, array) => ({
        ...area,
        show: array[i].aksesCameraCam.length > 0,
        aksesCameraCam: area.aksesCameraCam.filter((camera) =>
          camera.cameraName
            .toLowerCase()
            .includes(this.search.toLowerCase())
        ),
      }));
    },
  },
  methods: {
    // checkAreaInput() {
    //   setTimeout(() => {
    //     this.filteredCamera.forEach(area => {
    //       if (area.isSelected == 1) {
    //         area.aksesCameraCam.forEach(cam => cam.isSelected = 1)
    //       }
    //       // if (area.isSelected == 0) {
    //       //   area.aksesCameraCam.forEach(cam => cam.isSelected = 0)
    //       //  }
    //     })
    //     this.$emit('input', this.cameras)
    //     this.$emit('save', this.cameras)
    //   }, 100)
    // },
     checkAreaInput(area) {
      setTimeout(() => {
      area.aksesCameraCam.forEach(cam => {
        cam.isSelected = area.isSelected;
      });
      this.$emit('input', this.cameras);
      this.$emit('save', this.cameras);
    }, 100);
    },
    checkCameraInput(area, camera) {
    const foundArea = this.cameras.find(a => a.areaId === area.areaId);
    if (foundArea) {
    const foundCamera = foundArea.aksesCameraCam.find(c => c.cameraId === camera.cameraId);
    if (foundCamera) {
      foundCamera.isSelected = camera.isSelected;
    }
    }
    this.$emit('input', this.cameras);
    this.$emit('save', this.cameras);
    },
    processCameraLists() {
    const treeView = this.value.map((area, j) => {
    const aksesCameraCam = area.aksesCameraCam.map((camera) => {
      return {
        ...camera,
        timeStart: new Date().getTime(),
        show: true,
        isSelected: this.edit ? camera.isSelected : 0,
      };
    });

    const isSelected = aksesCameraCam.some(camera => camera.isSelected === 1);

    return {
      areaId: area.areaId,
      areaName: area.areaName,
      show: j === 0, // make opened first item
      isSelected: isSelected ? 1 : 0, // set the parent isSelected based on children's status
      aksesCameraCam: aksesCameraCam,
    };
  });
  
  this.cameras = treeView;
    },
    // async getCameras() {
    //   try {
    //     this.isLoadingCamera = true;
    //     const { data } = await api.getAksesCameraPerSite({ siteId: this.site });
    //     console.log(data.data)
    //     // modified data
    //     const treeView = data.data.map((area, j) => {
    //       return {
    //         areaId: area.areaId,
    //         areaName: area.areaName,
    //         show: j === 0, // make opened first item
    //         isSelected: 0,
    //         aksesCameraCam: area.aksesCameraCam.map((camera) => {
    //           return {
    //             ...camera,
    //             timeStart: new Date().getTime(),
    //             show: true,
    //             isSelected: 0,
    //           };
    //         }),
    //       };
    //     });
    //     // final data
    //     this.cameras = treeView;
    //   } catch (error) {
    //     this.$vs.notify({
    //       title: "Failed",
    //       text: "Error while fetching cameras",
    //       color: "danger",
    //       position: "top-right",
    //     });
    //   } finally {
    //     this.isLoadingCamera = false;
    //   }
    // },
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/player/views.scss";

.sidebar {
  width: inherit;
  border: none;

  ul ul li div {
    cursor: default;
  }
}
.treview-wrapper .sidebar__list {
  padding-left: 1.9rem;
}

.treview-wrapper > .sidebar__list {
  padding-left: 0 !important;
}
</style>